// import { cosh } from "core-js/fn/number";

//accounts
export const STORE_ACCOUNTS_TREE = 'STORE_ACCOUNTS_TREE ';
export const STORE_MAIN_BOX = 'STORE_MAIN_BOX'
export const STORE_ACCOUNTS = 'STORE_ACCOUNTS'
export const STORE_ONE_ACCOUNT = 'STORE_ONE_ACCOUNT';
//config
export const STORE_CONFIGS = 'STORE_CONFIGS';

//bonds
export const STORE_ONE_BOND = 'STORE_ONE_BOND'
export const DELETE_BOND = 'DELETE_BOND'
export const STORE_FILTERED_SIMPLIFIED_BONDS = 'STORE_FILTERED_SIMPLIFIED_BONDS'
export const DELETE_SIMPLIFIED_BOND = 'DELETE_SIMPLIFIED_BOND'
export const STORE_SIMPLIFIED_ACCOUNTING_BONDS = 'STORE_SIMPLIFIED_ACCOUNTING_BONDS'
export const STORE_ONE_SIMPLIFIED_ACCOUNTING_BOND = 'STORE_ONE_SIMPLIFIED_ACCOUNTING_BOND'
export const DELETE_SIMPLIFIED_ACCOUNTING_BOND = 'DELETE_SIMPLIFIED_ACCOUNTING_BOND'
export const DELETE_SIMPLIFIED_CASH_BOND = 'DELETE_SIMPLIFIED_CASH_BOND'
export const STORE_SIMPLIFIED_CASH_BONDS = 'STORE_SIMPLIFIED_CASH_BONDS'
export const STORE_ONE_SIMPLIFIED_CASH_BOND = 'STORE_ONE_SIMPLIFIED_CASH_BOND'
export const STORE_NOT_POSTED_BONDS = 'STORE_NOT_POSTED_BONDS'
export const STORE_ONE_ENTRY = 'STORE_ONE_ENTRY';

//entries
export const STORE_JOURNAL = 'STORE_JOURNAL'

//statements
export const STORE_ACCOUNT_STATEMENT_SUMMARY = 'STORE_ACCOUNT_STATEMENT_SUMMARY'
export const STORE_ACCOUNT_STATEMENT = 'STORE_ACCOUNT_STATEMENT'
export const STORE_ACCOUNT_CUSTOM_STATEMENT = 'STORE_ACCOUNT_CUSTOM_STATEMENT'
export const STORE_TRIAL_BALANCE = 'STORE_TRIAL_BALANCE'
export const STORE_FINAL_ACCOUNT = 'STORE_FINAL_ACCOUNT'
export const STORE_BOX_BALANCE = 'STORE_BOX_BALANCE'
export const STORE_ONE_ADVANCED_ENTRY = 'STORE_ONE_ADVANCED_ENTRY'
export const STORE_MATCHED_ENTRIES = 'STORE_MATCHED_ENTRIES'
export const STORE_STATISTICS = 'STORE_STATISTICS'
export const STORE_INVENTORY_REPORT = 'STORE_INVENTORY_REPORT'
export const STORE_MATERIAL_STATEMENT = 'STORE_MATERIAL_STATEMENT'
export const STORE_SALES_STATEMENT = 'STORE_SALES_STATEMENT'

//currencies
export const STORE_EQUIVALENT_MONEY_AMOUNT = 'STORE_EQUIVALENT_MONEY_AMOUNT'
export const STORE_CURRENCIES = 'STORE_CURRENCIES'
export const STORE_ONE_CURRENCY = 'STORE_ONE_CURRENCY'

//custom-statements
export const STORE_CUSTOM_STATEMENTS = 'STORE_CUSTOM_STATEMENTS'
export const STORE_ONE_CUSTOM_STATEMENT = 'STORE_ONE_CUSTOM_STATEMENT'
export const DELETE_CUSTOM_STATEMENT = 'DELETE_CUSTOM_STATEMENT'

//auth
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const STORE_USER = 'STORE_USER'

//financial-files
export const STORE_FINANCIAL_FILES = 'STORE_FINANCIAL_FILES'
export const STORE_ONE_FINANCIAL_FILE = 'STORE_ONE_FINANCIAL_FILE'
export const DELETE_FINANCIAL_FILE = 'DELETE_FINANCIAL_FILE'
export const STORE_DEFAULT_FINANCIAL_FILE_ACCOUNTS = 'STORE_DEFAULT_FINANCIAL_FILE_ACCOUNTS'

//weather
export const STORE_USER_IP = 'STORE_USER_IP'
export const STORE_LOCATION = 'STORE_LOCATION'

//users
export const STORE_USERS = 'STORE_USERS'
export const STORE_ONE_USER = 'STORE_ONE_USER'
export const DELETE_USER = 'DELETE_USER'
export const STORE_ONLY_ONE_USER = 'STORE_ONLY_ONE_USER'

//materials
export const STORE_MATERIALS = 'STORE_MATERIALS'
export const STORE_MATERIALS_TREE = 'STORE_MATERIALS_TREE'
export const STORE_WAREHOUSE_MATERIALS = 'STORE_WAREHOUSE_MATERIALS'
export const STORE_ONE_MATERIAL = 'STORE_ONE_MATERIAL'
export const DELETE_MATERIAL = 'DELETE_MATERIAL'
export const STORE_UPDATED_MATERIALS_TREE = 'STORE_UPDATED_MATERIALS_TREE'

//warehouses
export const STORE_WAREHOUSES = 'STORE_WAREHOUSES'
export const STORE_ONE_WAREHOUSE = 'STORE_ONE_WAREHOUSE'
export const STORE_DEFAULT_WAREHOUSE = 'STORE_DEFAULT_WAREHOUSE'
export const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE'

//unitSizes
export const STORE_UNIT_SIZES = 'STORE_UNIT_SIZES'
export const STORE_ONE_UNIT_SIZE = 'STORE_ONE_UNIT_SIZE'
export const DELETE_UNIT_SIZE = 'DELETE_UNIT_SIZE'

//invoices
export const STORE_SIMPLIFIED_BUY_INVOICES = 'STORE_SIMPLIFIED_BUY_INVOICES'
export const STORE_ONE_SIMPLIFIED_BUY_INVOICE = 'STORE_ONE_SIMPLIFIED_BUY_INVOICE'
export const DELETE_SIMPLIFIED_BUY_INVOICE = 'DELETE_SIMPLIFIED_BUY_INVOICE'
export const STORE_SIMPLIFIED_SALE_INVOICES = 'STORE_SIMPLIFIED_SALE_INVOICES'
export const STORE_SIMPLIFIED_SALE_REFUND_INVOICES = 'STORE_SIMPLIFIED_SALE_REFUND_INVOICES'
export const STORE_SIMPLIFIED_BUY_REFUND_INVOICES = 'STORE_SIMPLIFIED_BUY_REFUND_INVOICES'
export const STORE_ONE_SIMPLIFIED_SALE_INVOICE = 'STORE_ONE_SIMPLIFIED_SALE_INVOICE'
export const DELETE_SIMPLIFIED_SALE_INVOICE = 'DELETE_SIMPLIFIED_SALE_INVOICE'
export const STORE_ONE_BUY_INVOICE = 'STORE_ONE_BUY_INVOICE'
export const STORE_ONE_SALE_INVOICE = 'STORE_ONE_SALE_INVOICE'
export const STORE_ONE_BUY_INVOICE_ENTRY = 'STORE_ONE_BUY_INVOICE_ENTRY';
export const STORE_ONE_SALE_INVOICE_ENTRY = 'STORE_ONE_SALE_INVOICE_ENTRY';

//general
export const CLEAR = 'CLEAR';
export const DELETE_ONE_ENTRY = 'DELETE_ONE_ENTRY'
//systemInfo
export const STORE_SYSTEM_PATHS = 'STORE_SYSTEM_PATHS';

//material journal
export const STORE_MATERIALS_JOURNALS = 'STORE_MATERIALS_JOURNALS';
export const STORE_ONE_MATERIALS_JOURNAL= 'STORE_ONE_MATERIALS_JOURNAL';
export const STORE_ONE_MATERIAL_ENTRY= 'STORE_ONE_MATERIAL_ENTRY';
export const STORE_MATERIALS_JOURNAL_ENTRIES = 'STORE_MATERIALS_JOURNAL_ENTRIES';

// manufacturing
export const STORE_MANUFACTURING_BONDS = 'STORE_MANUFACTURING_BONDS';
export const STORE_ONE_MANUFACTURING_BOND = 'STORE_ONE_MANUFACTURING_BOND';
export const STORE_MANUFACTURING_ENTRIES = 'STORE_MANUFACTURING_ENTRIES';
export const STORE_ONE_MANUFACTURING_ENTRY = 'STORE_ONE_MANUFACTURING_ENTRY';
export const STORE_MANUFACTURING_RAW_MATERIALS = 'STORE_MANUFACTURING_RAW_MATERIALS';

export const STORE_TRANSACTION_BONDS = 'STORE_TRANSACTION_BONDS'

export const STORE_WAREHOUSES_FOR_WAREHOUSE_KEEPER = 'STORE_WAREHOUSES_FOR_WAREHOUSE_KEEPER'

export const STORE_ROLES = 'STORE_ROLES'

export const STORE_STATEMENT_ADVANCE = 'STORE_STATEMENT_ADVANCE'
export const STORE_MATERIAL_FLOW_INVOICE = 'STORE_MATERIAL_FLOW_INVOICE'

// user permissoins
export const STORE_USER_PERMISSIONS = 'STORE_USER_PERMISSIONS'
export const STORE_USER_TYPE = 'STORE_USER_TYPE';
export const STORE_PERMISSION_USER_FOR_FINANCIAL_FILE = 'STORE_PERMISSION_USER_FOR_FINANCIAL_FILE'

// audit logs
export const STORE_AUDIT_LOGS = 'STORE_AUDIT_LOGS'

// invoice categories
export const STORE_INVOICE_CATEGORIES = 'STORE_INVOICE_CATEGORIES'
export const STORE_DEFAULT_INVOICES_CATEGORIES = 'STORE_DEFAULT_INVOICES_CATEGORIES'

export const STORE_DELIVERY_STATUS = 'STORE_DELIVERY_STATUS'
// settings
export const STORE_SETTINGS = 'STORE_SETTINGS'
export const STORE_GLOBAL_SETTINGS = 'STORE_GLOBAL_SETTINGS'
//orders
export const STORE_ORDERS = 'STORE_ORDERS'
//offers
export const STORE_OFFERS = 'STORE_OFFERS'
//backups
export const STORE_BACKUPS = 'STORE_BACKUPS'
//colors 
export const STORE_COLORS = 'STORE_COLORS'

export const STORE_IS_ADVANCED_ACCOUNTANT = 'STORE_IS_ADVANCED_ACCOUNTANT'